/*
  Node Constants

  Centralized constants for node components in the journey graph.
  These values control dimensions, colors, and styling configurations.
*/

/**
 * Standard node dimensions used across different node types
 */
export const NODE_DIMENSIONS = {
  START_WIDTH: 120,
  START_HEIGHT: 32,
  STANDARD_WIDTH: 180,
  STANDARD_HEIGHT: 32,
  RECONCILIATION_WIDTH: 200,
  RECONCILIATION_HEIGHT: 60,
} as const;

/**
 * Standard node statuses mapped to their visual representations
 */
export const NODE_STATUS = {
  NEUTRAL: 'neutral',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info',
} as const;

/**
 * Icon names for different node types
 */
export const NODE_ICONS = {
  START: 'Enter',
  ENTER: 'Enter',
  ACTION: 'Action',
  WORKFLOW: 'Workflows',
  PORTFOLIO: 'Portfolio',
  FINGERPRINT: 'Fingerprint',
  PENCIL: 'Pencil',
  RETRY: 'Retry',
  RECONCILIATION: 'Reconciliation',
  CIRCLE_CHECK: 'CircleCheck',
  XMARK: 'Xmark',
} as const;

/**
 * Colors for status badges and indicators
 */
export const BADGE_COLORS = {
  LOADING: {
    background: '#dbeafe',
    text: '#1e40af',
  },
  ERROR: {
    background: '#fee2e2',
    text: '#b91c1c',
  },
} as const;

/**
 * Expanded workflow container styling
 */
export const EXPANDED_WORKFLOW = {
  BACKGROUND: 'rgba(59, 130, 246, 0.1)',
  BORDER_COLOR: '#3b82f6',
  BORDER_WIDTH: 2,
  BORDER_RADIUS: 8,
  MIN_WIDTH: 200,
  TEXT_COLOR: '#1e40af',
  VERSION_TEXT_COLOR: '#64748b',
} as const;

